import { useEffect, useState } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';

type FeatureFlags = {
  queryConfigs: Record<string, any>;
  lad473: boolean;
};

const defaultFeatureFlags: FeatureFlags = {
  queryConfigs: {},
  lad473: false,
};

export function useFeatureFlags() {
  const flags = useFlags();
  const [featureFlags, setFeatureFlags] = useState<FeatureFlags>(defaultFeatureFlags);

  useEffect(() => {
    setFeatureFlags({
      queryConfigs: flags?.queryConfigs ?? {},
      lad473: flags?.lad473 ?? false,
    });
  }, [flags]);

  return featureFlags;
}
